/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from "react"
import { Box, IconButton, Paper, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import theme from "src/theme/light"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { useHistory } from "react-router-dom"
import { ListagemItem, InversorModuloResponse, ModuloListagem, ModuloPorRegiaoListagemResponse, Option } from "src/components/projetos/types"
import { setPersonalizadoTabDisabledStatus } from "src/store/vendas/projetos/actions"
import { Layout } from "../../_layouts"
import { redirecionarParaProjetoVertical } from "src/components/projetos/utils/redirecionarParaProjetoVertical"
import { POTENCIA_MINIMA_ENGENHARIA, MODULO_POTENCIA_MAXIMA_ATTR, INVERTER_MAX_POWER_ATTR, MODULO_POWER_ATTR, MODULO_POTENCIA_MINIMA_ATTR, NOVO_PROJETO_ENGENHARIA, INVERSOR_CARREGADOR_TENSAO_MAXIMA_ENTRADA, INVERSOR_ONDA_POTENCIA_MAXIMA_ATTR, CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA_ATTR, TIPOS_SOLUCAO_OPTIONS, MODULO_MODULO_TENSAO_VOC_ATTR } from "src/components/projetos/constants"
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider"
import { potenciaTotalMaiorQuePotenciaMaxima } from "src/components/projetos/utils/potenciaTotalMaiorQuePotenciaMaxima"
import { checarParametroRegiaoPotencia } from "src/components/projetos/utils/checarParametroRegiaoPotencia"
import { potenciaTotalMenorQuePotenciaMinima } from "src/components/projetos/utils/potenciaTotalMenorQuePotenciaMinima"
import { ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA, ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA, ALERT_POPUP_PARCEIRO, alertsList$, clearIntervalAlerts, setAlertsList, startIntervalAlerts, TAlertsDom } from "src/framework/store/ProcessarFilaMensagensStore"
import { FindInPageOutlined } from "@mui/icons-material"
import ModulosListMobile from "src/components/projetos/containers/Mobile/ModulosListMobile"
import InversoresListMobile from "src/components/projetos/containers/Mobile/InversoresListMobile"
import { ID_CONTROLADOR, ID_INVERSOR_CARREGADOR } from "src/components/componentes/types";
import { useProjetoPersonalizadoOffgridStore } from "src/store/vendas/projetos/personalizado_offgrid/personalizadoOffgrid.store";
import { ProjetoPersonalizadoOffgridData, TipoSolucaoType } from "src/store/vendas/projetos/personalizado_offgrid/personalizadoOffgrid.types";
import { checarNumeroMaximoDeItens } from "../../utils/checarNumeroMaximoDeItens";
import { showMaxItemsAlert } from "../../utils/showMaxItemsAlert";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { showInvalidItemsAlert } from "../../utils/showInvalidItemsAlert";

const useStyles = makeStyles({
  quantityHelperText: {
    color:  theme.palette.error.main,
    display: 'block',
    textAlign: 'left',
    marginLeft: 25,
  },
  warningText: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  moduleTitle: {
    fontWeight: 600,
  },
  radioButton: {
    marginRight: 14,
  }
})

interface GeradorProps {
  onClickBack: () => void
  onClickNext: () => void
}

const componenteProvider = new ComponenteProvider()
const buscarVinculosModulo = async (moduloId: number, lista: ListagemItem[] = [], filters: { regiao_id?: number[]; categorias?: number[]; segmento?: string } = {}) => {
  if (moduloId) {
    const resultItems = await componenteProvider.buscarVinculosModuloId(moduloId, filters)
    if(!resultItems.length) return []

    const result: ListagemItem[] = resultItems.map((item: InversorModuloResponse): ListagemItem => {
      const potencia = item.atributos.find(item => item.atributo === INVERTER_MAX_POWER_ATTR)
      const potenciaMaximaEntradaCC = item.atributos.find(item => item.atributo === INVERSOR_ONDA_POTENCIA_MAXIMA_ATTR)
      const tensaoMaximaEntrada = item.atributos.find(item => item.atributo === INVERSOR_CARREGADOR_TENSAO_MAXIMA_ENTRADA)
      const maximaPotenciaFV = item.atributos.find(item => item.atributo === CONTROLADOR_MAXIMA_POTENCIA_FOTOVOLTAICA_ATTR)
      const savedItem = lista.find(i => i.componente_id === item.id)

      return {
        potenciaMaximaEntradaCC: Number(potenciaMaximaEntradaCC?.valor || 0),
        tensaoMaximaEntrada: Number(tensaoMaximaEntrada?.valor || 0),
        maximaPotenciaFV: Number(maximaPotenciaFV?.valor || 0),
        componente_id: item.id,
        nome: item.nome,
        modelo: item?.modelo,
        descricao: item.descricao,
        quantidade: savedItem?.quantidade || 0,
        altura: item.altura,
        largura: item.largura,
        peso: item.peso,
        valor: 0,
        categoria_componentes_id: item.categoria_componentes_id,
        potencia: Number(potencia?.valor || 0),
        valor_unitario: savedItem?.valor_unitario || 0,
        exibir_popup_parceiro: item?.exibir_popup_parceiro,
      }
    })
    return result;
  }
}

let timerBuscarVinculos: NodeJS.Timeout;

const Gerador = ({ onClickNext, onClickBack }: GeradorProps) => {
  const projetoState = useProjetoPersonalizadoOffgridStore(store => store.state.data);
  const { changeValue, changeValidation, changeModal, reset} = useProjetoPersonalizadoOffgridStore(store => store.actions);
  const history = useHistory();
  const classes = useStyles();

  const [modulosList, setModulosList] = useState<ModuloListagem[]>([]);
  const [tipoSolucao, setTipoSolucao] = useState<Option<number> | null>(projetoState?.tipo_solucao || null);
  const [fraseParceiroExibidoList, setFraseParceiroExibidoList] = useState<number[]>([]);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const showMaxPowerNotify = useCallback(() => {
    redirecionarParaProjetoVertical({
      onNegation: () => {
        reset()
        changeValue(NOVO_PROJETO_ENGENHARIA)
        history.push('/projetos/verticais/novo', { allowAccess: true, tipo: 'personalizado_offgrid' })
      },
      yesText: 'Continuar personalizando'
    })
  },[history, projetoState])

  const selectedModulo = useMemo(()=>{
    return modulosList.find(item => item.selecionado)
  },[modulosList])

  const listarVinculos = useCallback((state: ProjetoPersonalizadoOffgridData) => {
    clearTimeout(timerBuscarVinculos)
    timerBuscarVinculos = setTimeout(() => {
      const moduloSelecionado = state.modulosList?.find(item => item.selecionado)
      if (!moduloSelecionado) return;
      const regioesIds = state.regioes.map(item => item.id)

      buscarVinculosModulo(moduloSelecionado.componente_id, state.controladoresList, { categorias: [ID_CONTROLADOR], regiao_id: regioesIds, segmento: "off"  }).then(result => {
        changeValue({ controladoresList: result || [] })
      })

      buscarVinculosModulo(moduloSelecionado.componente_id, state.carregadoresList, { categorias: [ID_INVERSOR_CARREGADOR], regiao_id: regioesIds, segmento:  "off" }).then(result => {
        changeValue({ carregadoresList: result || [] })
      })
    }, 300)
  },[]);

  useEffect(()=>{
    const carregarDadosIniciais = async () => {
      const currentRegioes = projetoState.regioes || []
      if (!currentRegioes.length) return;

      componenteProvider.buscarModulosPorRegiao(currentRegioes.map((item: any) => item.id), undefined, 'personalizado', undefined, undefined, undefined, projetoState.segmento?.includes("on") ? "on" : "off").then((res) => {
        if(res.length) {
          const items: ModuloPorRegiaoListagemResponse[] = res || []

          const result = items.map((modulo: ModuloPorRegiaoListagemResponse) => {
            const potencia = modulo.atributos.find(item => item.atributo === MODULO_POWER_ATTR)
            const savedItem = projetoState.modulosList ? projetoState.modulosList.find(item => item.componente_id === modulo.id) : null

            listarVinculos(projetoState)

            const potenciaMaxima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MAXIMA_ATTR)
            const potenciaMinima = modulo.atributos.find(item => item.atributo === MODULO_POTENCIA_MINIMA_ATTR)
            const tensaoVocModulo = modulo.atributos.find(item => item.atributo === MODULO_MODULO_TENSAO_VOC_ATTR)

            return {
              potenciaMaxima: Number(potenciaMaxima?.valor || 0),
              potenciaMinima: Number(potenciaMinima?.valor || 0),
              tensaoVocModulo: Number(tensaoVocModulo?.valor || 0),
              componente_id: modulo.id,
              inversoresTipos: [],
              categoria_componentes_id: modulo.categoria_componentes_id,
              potencia: Number(potencia?.valor || 0),
              faturamento: modulo.data_previsao_faturamento ? new Date(modulo.data_previsao_faturamento).toISOString() : undefined,
              nome: modulo.nome,
              descricao: modulo.descricao,
              quantidade: savedItem?.quantidade || 0,
              selecionado: savedItem?.selecionado || false,
              categoria: modulo.categoria_componentes_nome,
              altura: modulo.altura,
              largura: modulo.largura,
              peso: modulo.peso,
              valor: 0, // Calculado no backend
              comprimento: modulo.comprimento,
              valor_unitario: savedItem?.valor_unitario || 0,
              regioes_parametros: modulo?.regioes_parametros,
              exibir_popup_parceiro: modulo?.exibir_popup_parceiro,
            }
          })
          setModulosList(result)
          changeValue({ modulosList: result })
        }

        // iniciando intervalo de mensagens
        clearIntervalAlerts();
        startIntervalAlerts();
      })
    }

    carregarDadosIniciais();
  },[projetoState.regioes])

  const isGreatherThanPowerLimitForCustomProjects = useCallback(()=>{
    const pot = selectedModulo?.potencia || 0
    const numModulos = selectedModulo?.quantidade || 0
    const powerInKw = (pot * numModulos) / 1000
    return powerInKw > POTENCIA_MINIMA_ENGENHARIA
  },[selectedModulo])

  const checarSePotenciaTotalMaiorQuePotenciaMaxima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMaxima: number; } =>{
    return potenciaTotalMaiorQuePotenciaMaxima(moduloSelecionado)
  },[selectedModulo]);

  const checarSePotenciaTotalMenorQuePotenciaMinima = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; potenciaMinima: number; } =>{
    return potenciaTotalMenorQuePotenciaMinima(moduloSelecionado)
  },[selectedModulo]);

  const checarPotenciaTotalEstaNoRangePotenciaRegiao = useCallback(( moduloSelecionado: ModuloListagem | null = selectedModulo || null ): { status: boolean; parametro: any; } =>{
    return checarParametroRegiaoPotencia(moduloSelecionado)
  },[selectedModulo]);
  
  const checkItensIsInvalid = useCallback((): { status: boolean, type?: TipoSolucaoType } => {
    if (!selectedModulo) return { status: false }
    if (!tipoSolucao?.value) return { status: false }

    const controladoresList = projetoState?.controladoresList?.filter(controlador => controlador?.quantidade > 0);
    if (controladoresList?.length) {
      const totalPotenciaModulos = (selectedModulo?.potencia || 0) * (selectedModulo?.quantidade || 1);
      const potenciaMaximaControlador = controladoresList?.reduce((acc, controlador) => {
        return acc + (Number(controlador.maximaPotenciaFV || 0) * Number(controlador?.quantidade || 1));
      }, 0);

      if (totalPotenciaModulos > potenciaMaximaControlador) {
        return { status: true, type: 'controlador' }
      }
    }

    const carregadoresList = projetoState?.carregadoresList?.filter(carregador => carregador?.quantidade > 0);
    if (carregadoresList?.length) {
      const totalTensaoVocModulos = (selectedModulo?.tensaoVocModulo || 0) * (selectedModulo?.quantidade || 1);
      const tensaoMaximaCarregador = carregadoresList?.reduce((acc, controlador) => {
        return acc + (Number(controlador.tensaoMaximaEntrada || 0) * Number(controlador?.quantidade || 1));
      }, 0);

      if (totalTensaoVocModulos > tensaoMaximaCarregador) {
        return { status: true, type: 'carregador' }
      }
    }
    return { status: false }
  },[projetoState?.controladoresList, projetoState?.carregadoresList, selectedModulo, tipoSolucao]);

  const handleChangeModuleQuantity = useCallback((id: number, value: string)=> {
    const quantidade = Number(value || 0);
    const state = { ...projetoState }
    const newModulosList = modulosList.map((item) => ({ ...item, quantidade }));

    changeValue({ modulosList: newModulosList})
    setModulosList(newModulosList)

    listarVinculos(state)
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, listarVinculos, projetoState, modulosList, changeValue])

  const checkChargeControllerQuantityIsInvalid = useCallback((id?: number, value?: number) => {
    const itens = projetoState?.controladoresList || [];
    const quantity = selectedModulo?.quantidade || 0;
    return checarNumeroMaximoDeItens(itens, quantity, id, value);
  }, [projetoState?.controladoresList, selectedModulo]);

  const checkChargerQuantityIsInvalid = useCallback((id?: number, value?: number) => {
    const itens = projetoState?.carregadoresList || [];
    const quantity = selectedModulo?.quantidade || 0;
    return checarNumeroMaximoDeItens(itens, quantity, id, value);
  }, [projetoState?.carregadoresList, selectedModulo]);

  const handleChangeQuantity = useCallback((id: number, value: string, list: ListagemItem[], tipo: TipoSolucaoType, checkQuantityIsInvalid: (id: number, value: number) => boolean) => {
    const _alertasList: TAlertsDom[] = alertsList$.getValue();
    const quantidade = Number(value || 0);
    
    const listKey = (tipo === 'controlador') ? 'controladoresList' : 'carregadoresList';
    const newList = list.map(item => item.componente_id === id ? { ...item, quantidade } : item );
    const selected = newList.find(item => item.componente_id === id);

    if (selected?.exibir_popup_parceiro) {
      const idx = fraseParceiroExibidoList.findIndex(c => c === id);
      if (idx < 0 && quantidade > 0) {
        _alertasList.push({ alert: ALERT_POPUP_PARCEIRO });
        setFraseParceiroExibidoList([...fraseParceiroExibidoList, id]);
      } else if (quantidade === 0 && idx >= 0) {
        setFraseParceiroExibidoList(fraseParceiroExibidoList?.filter(i => i !== id));
      }
    }

    changeValue({ [listKey]: newList });

    const quantityIsInvalid = checkQuantityIsInvalid(id, quantidade);
    if (quantityIsInvalid) {
      showMaxItemsAlert();
    }
  }, [projetoState?.controladoresList, projetoState?.carregadoresList, changeValue]);
  
  const handleSelect = useCallback((id: number) => {
    const currentSelected = modulosList.find(item => item.selecionado)
    if (currentSelected?.componente_id === id) return;
    setTipoSolucao(null);

    const state = { ...projetoState }
    const newModulosList = modulosList.map((item) => {
      const selecionado = item.componente_id === id;
      return {
        ...item,
        selecionado,
        quantidade: 0
      };
    });

    state.modulosList = newModulosList
    changeValue({ 
      modulosList: newModulosList, 
      estruturasSelecionadas: [], 
      carregadoresList: projetoState?.carregadoresList?.map(i => ({...i, quantidade: 0})) || [], 
      controladoresList: projetoState?.controladoresList?.map(i => ({...i, quantidade: 0})) || [] 
    })
    setModulosList(newModulosList)
    listarVinculos(state)
  },[listarVinculos, projetoState, modulosList, changeValue])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = projetoState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[projetoState?.modulosList]);

  const potenciaInvalida = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_ENGENHARIA;
  },[potenciaTotal]);

  const nextButtonIsDisabled = useMemo(()=>{
    if (!tipoSolucao?.value) return true;
    const selectedModulo = modulosList.find(item => item.selecionado);
    const controladoresTotal = projetoState?.controladoresList?.reduce((acc,curr) => acc + curr.quantidade, 0);
    const carregadoresTotal = projetoState?.carregadoresList?.reduce((acc,curr) => acc + curr.quantidade, 0);

    if (!selectedModulo || selectedModulo?.quantidade === 0) return true;
    if (checkChargeControllerQuantityIsInvalid() || checkChargerQuantityIsInvalid()) {
      showMaxItemsAlert();
      return true
    }

    if (selectedModulo?.regioes_parametros?.length) {
      if (checarPotenciaTotalEstaNoRangePotenciaRegiao().status === false) return true;
    } else {
      if (checarSePotenciaTotalMaiorQuePotenciaMaxima().status) return true;
      if (checarSePotenciaTotalMenorQuePotenciaMinima().status) return true;
    }
    if (checkItensIsInvalid().status) return true;
    if (isGreatherThanPowerLimitForCustomProjects()) return true;
    if (controladoresTotal === 0 && carregadoresTotal === 0) return true;
    if (potenciaInvalida) return true;
    return false;
  },[checarSePotenciaTotalMaiorQuePotenciaMaxima, checarSePotenciaTotalMenorQuePotenciaMinima, checarPotenciaTotalEstaNoRangePotenciaRegiao, isGreatherThanPowerLimitForCustomProjects, modulosList, projetoState?.controladoresList, projetoState?.carregadoresList, checkItensIsInvalid, checkChargeControllerQuantityIsInvalid, checkChargerQuantityIsInvalid, potenciaInvalida, tipoSolucao])

  useEffect(()=>{
    setPersonalizadoTabDisabledStatus('estruturas', nextButtonIsDisabled)
    changeValidation({ gerador: !nextButtonIsDisabled });
  },[nextButtonIsDisabled])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!selectedModulo) return;
      const _alertasList: TAlertsDom[] = alertsList$.getValue();

      // Verifica parâmetros de potência configurada
      if (selectedModulo.regioes_parametros?.length) {
        const { status, parametro } = checarParametroRegiaoPotencia(selectedModulo);

        if (!status) {
          _alertasList.push({
            alert: ALERT_MOSTRAR_PARAMETRO_REGIAO_POTENCIA,
            data: {
              potencia_inicial: parametro?.potencia_inicial,
              potencia_final: parametro?.potencia_final
            }
          });
        }
      } else {
        const { status: potenciaInvalida, potenciaMaxima } = potenciaTotalMaiorQuePotenciaMaxima(selectedModulo);

        if (potenciaInvalida) {
          _alertasList.push({
            alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
            data: { potencia_maxima: potenciaMaxima }
          });
        }

        const { status: potenciaMinimaInvalida, potenciaMinima } = potenciaTotalMenorQuePotenciaMinima(selectedModulo);

        if (potenciaMinimaInvalida) {
          _alertasList.push({
            alert: ALERT_MOSTRAR_POTENCIA_TOTAL_MAIOR_QUE_POTENCIA_MAXIMA,
            data: { potencia_minima: potenciaMinima }
          });
        }
      }

      if (_alertasList.length) {
        setAlertsList(_alertasList);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [selectedModulo, checarParametroRegiaoPotencia, potenciaTotalMaiorQuePotenciaMaxima, potenciaTotalMenorQuePotenciaMinima]);

  useEffect(() => {
    // Verifica se o projeto ultrapassa o limite de potência
    if (isGreatherThanPowerLimitForCustomProjects()) {
      showMaxPowerNotify()
    }

    // Verifica se exibe frase parceiro
    const _alertasList: TAlertsDom[] = alertsList$.getValue();
    if (selectedModulo && selectedModulo.exibir_popup_parceiro) {
      const idx = fraseParceiroExibidoList.findIndex(c => c === selectedModulo.componente_id);
      if (idx < 0) {
        setFraseParceiroExibidoList([...fraseParceiroExibidoList, selectedModulo.componente_id]);
        _alertasList.push({ alert: ALERT_POPUP_PARCEIRO });
      } else if (selectedModulo?.quantidade === 0 && idx >= 0) {
        setFraseParceiroExibidoList(fraseParceiroExibidoList?.filter(i => i !== selectedModulo.componente_id));
      }
    }
  },[selectedModulo?.componente_id, selectedModulo?.quantidade]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const result = checkItensIsInvalid();

      // Verifica se os itens respeitam as regras de cálculo
      if (result.status && result.type) {
        showInvalidItemsAlert(result.type);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [checkItensIsInvalid]);

  const localTiposSolucaoOptions = useMemo(()=> {
    if (!projetoState?.controladoresList?.length && !projetoState?.carregadoresList?.length) return [];
    if (!projetoState?.controladoresList?.length) return TIPOS_SOLUCAO_OPTIONS.filter(item => item.value !== ID_CONTROLADOR);
    if (!projetoState?.carregadoresList?.length) return TIPOS_SOLUCAO_OPTIONS.filter(item => item.value !== ID_INVERSOR_CARREGADOR);
    return TIPOS_SOLUCAO_OPTIONS;
  },[projetoState?.controladoresList, projetoState?.carregadoresList])
  
  const renderModulos = useCallback(() => {
    if (isMobile) {
      return (
        <ModulosListMobile 
          modulosList={modulosList || []}
          handleSelect={handleSelect}
          handleChangeModuleQuantity={handleChangeModuleQuantity}
          handleOpenModalDadosTecnicos={changeModal}
          stringAvatarImg={""}
          microinversorAvatarImg={""}
          titulo="* Módulos"
          helperText="Mínimo 1."
        />
      )
    }

    return (
      <TableContainer component={Paper}>
        <Table aria-label="listagem de modulos disponíveis">
          <TableHead>
            <TableRow>
              <TableCell align='left'><strong>Módulos</strong></TableCell>
              <TableCell align='center'><strong>Quantidade</strong></TableCell>
              <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {modulosList.map((row) => (
              <TableRow key={row.componente_id}>
                <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                  <Box display='flex'>
                    <Radio className={classes.radioButton} value={row.componente_id} checked={row.selecionado} onClick={() => handleSelect(row.componente_id)} />
                  
                    <Box textAlign={'left'}>
                      <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                        {row.nome}
                      </Typography>
                      {row.descricao && (
                        <Typography variant='body2' color='textSecondary'>
                        <span className={classes.warningText}>Atenção</span>: {row.descricao}
                        </Typography>
                      )}
                      {row.faturamento && (
                        <Typography variant='body2' color='textSecondary'>
                          Previsão de faturamento: {Formater.toString(row.faturamento, TypeRecords.DATE)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align='center' component="th">
                  {row.selecionado && (
                    <Box width="180px" margin={"0 auto"}>
                      <InputQuantidade value={row.quantidade} onChange={(v: any) => handleChangeModuleQuantity(row.componente_id, v)} />
                      <small className={classes.quantityHelperText}>Mínimo 1.</small>
                    </Box>
                  )}
                </TableCell>
                <TableCell align='center' component="th">
                  <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                    <IconButton size="large" onClick={() => row.componente_id && changeModal({ detalhesComponenteId: row.componente_id })}>
                      <FindInPageOutlined htmlColor="black" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }, [classes, handleSelect, handleChangeModuleQuantity, modulosList])

  const renderControladores = useCallback(() => {
    const itens = projetoState?.controladoresList || [];
    if (!selectedModulo || !itens?.length || tipoSolucao?.value !== ID_CONTROLADOR) return null;

    return (
      <Box mt={isMobile ? 0 : 4}>
        {isMobile ? (
            <InversoresListMobile 
              inversoresList={itens || []}
              handleOpenModalDadosTecnicos={changeModal}
              handleChangeInverterQuantity={(id: number, value: string) => handleChangeQuantity(id, value, itens, "controlador", checkChargeControllerQuantityIsInvalid)}
              titulo="* Selecione a quantidade desejada de Controladores"
            />
          ) : (
            <TableContainer component={Paper}>
              <Table aria-label="listagem de controladores de carga disponíveis">
                <TableHead>
                  <TableRow>
                    <TableCell align='left'><strong>Selecione a quantidade desejada de Controladores</strong></TableCell>
                    <TableCell align='center'><strong>Quantidade</strong></TableCell>
                    <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itens?.map((row) => (
                    <TableRow key={row.componente_id}>
                      <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                        <Box textAlign={'left'}>
                          <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                            {row.nome}
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            <span className={classes.warningText}>Informações</span>: {row.descricao}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box width="180px" margin={"0 auto"}>
                          <InputQuantidade
                            value={row.quantidade} 
                            maxValue={selectedModulo?.quantidade}
                            onChange={(v: any) => handleChangeQuantity(row.componente_id, v, itens, "controlador", checkChargeControllerQuantityIsInvalid)} 
                          />
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                          <IconButton size="large" onClick={() => row.componente_id && changeModal({ detalhesComponenteId: row.componente_id })}>
                            <FindInPageOutlined htmlColor="black" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        }
      </Box>
    );
  }, [projetoState?.controladoresList, selectedModulo, tipoSolucao, classes, handleChangeQuantity, checkChargeControllerQuantityIsInvalid])

  const renderCarregadores = useCallback(()=> {
    const itens = projetoState?.carregadoresList || [];
    if (!selectedModulo || !itens.length || tipoSolucao?.value !== ID_INVERSOR_CARREGADOR) return null;

    return (
      <Box mt={isMobile ? 0 : 4}>
        {isMobile ? (
            <InversoresListMobile 
              inversoresList={itens || []}
              handleOpenModalDadosTecnicos={changeModal}
              handleChangeInverterQuantity={(id: number, value: string) => handleChangeQuantity(id, value, itens, "carregador", checkChargerQuantityIsInvalid)}
              titulo="* Selecione a quantidade desejada de Carregadores"
            />
          ) : (
            <TableContainer component={Paper}>
              <Table aria-label="listagem de carregadores disponíveis">
                <TableHead>
                  <TableRow>
                    <TableCell align='left'><strong>Selecione a quantidade desejada de Carregadores</strong></TableCell>
                    <TableCell align='center'><strong>Quantidade</strong></TableCell>
                    <TableCell align='center'><strong>Dados Técnicos</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itens?.map((row) => (
                    <TableRow key={row.componente_id}>
                      <TableCell style={{ maxWidth: '400px' }} align='right' component="th">
                        <Box textAlign={'left'}>
                          <Typography className={classes.moduleTitle} variant='body1' color='textPrimary'>
                            {row.nome}
                          </Typography>
                          <Typography variant='body2' color='textSecondary'>
                            <span className={classes.warningText}>Informações</span>: {row.descricao}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box width="180px" margin={"0 auto"}>
                          <InputQuantidade 
                            value={row.quantidade} 
                            maxValue={selectedModulo?.quantidade}
                            onChange={(v: any) => handleChangeQuantity(row.componente_id, v, itens, "carregador", checkChargerQuantityIsInvalid)} 
                          />
                        </Box>
                      </TableCell>

                      <TableCell align='center' component="th">
                        <Box display={"flex"} alignItems="center" justifyContent={"center"}>
                          <IconButton
                            onClick={() => row.componente_id && changeModal({ detalhesComponenteId: row.componente_id })}
                            size="large">
                              <FindInPageOutlined htmlColor="black" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        }
      </Box>
    );
  }, [projetoState?.carregadoresList, selectedModulo, tipoSolucao, classes, handleChangeQuantity, checkChargerQuantityIsInvalid])

  const handleClickNext = useCallback(() => {
    onClickNext()
  },[onClickNext])

    return (
      <>
        <Layout
          nextButtonIsDisabled={nextButtonIsDisabled}
          nextButtonDisabledTooltip='Para prosseguir, selecione um módulo e preencha a quantidade de unidades desejada e posteriormente a solução ideal para este projeto.'
          onClickBack={onClickBack}
          onClickNext={handleClickNext}
          title="Módulos, controladores e carregadores"
          subtitle="Escolha o módulo e controlador ou carregador ideal para compor o gerador e atender a demanda do seu cliente."
        >
          <Box p={2}>
            {renderModulos()}

            <Box mt={5}>
              <InputComboBoxList
                id={`select-tipos-solucao`}
                key={`select-tipos-solucao`}
                label={"* Tipo de solução"}
                textField="tipos_solucao"
                valueField="id"
                options={localTiposSolucaoOptions}
                value={tipoSolucao}
                autoComplete
                renderOptions={(option: any) => {
                  return `${option.text}`
                }}
                renderOptionsLabel={(option: any) => {
                  return `${option.text}`
                }}
                onChange={(value: any) => {
                  setTipoSolucao(value)
                  changeValue({ 
                    tipo_solucao: value, 
                    carregadoresList: projetoState?.carregadoresList?.map((item) => ({...item, quantidade: 0})), 
                    controladoresList: projetoState?.controladoresList?.map((item) => ({...item, quantidade: 0})) 
                  })
                }}
              />
            </Box>

            {renderControladores()}
            {renderCarregadores()}
          </Box>
        </Layout>
      </>
    )
}

export { Gerador }
